module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "brand",
    staticClass: "modal-mask",
    attrs: {
      "id": "brand"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [_c('div', {
    staticClass: "modalContent"
  }, [_c('label', {
    attrs: {
      "for": "listName"
    }
  }, [_vm._v(_vm._s(_vm.$t("addlist.label")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "textfield",
    attrs: {
      "type": "text",
      "id": "listName"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.name === '') ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Veuillez saisir un nom")]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flexContainer fright"
  }, [_c('button', {
    staticClass: "btn block pointer uppercase cancel",
    on: {
      "click": function($event) {
        _vm.close();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.cancel")))]), _vm._v(" "), _c('button', {
    staticClass: "btnExp",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.$t("addlist.add")))])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd81b8c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wishlist/AddList.vue
// module id = 3369
// module chunks = 0